import React, { useMemo } from 'react';
import {
  PAGE_NAMES,
  FILTER_LIST,
} from 'appenv';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import ArrowFowardIcon from '@material-ui/icons/ArrowForwardIosRounded';
import Routes from 'Routes';
// import { useHistory } from 'react-router-dom';
import FilterCategoryContainer from '../FilterCategoryContainer';
import FilterOption from '../FilterOption';
import FilterCheckboxOption from '../FilterCheckboxOption';

const HallFilterContainer = styled.div`
  width: 300px;
  height: 100%;
  overflow: auto;
  padding: 24px;
  color: #282B40;
  background: rgba(255, 255, 255, 0.8);

  @media only screen and (max-width: 959px) {
    display: none;
  }
`;

const FilterTitleContainer = styled.div`
  width: 100%;
`;

const MiniSiteNav = styled.div`
  width: 100%;
  padding-bottom: 12px;
`;

const StyledLink = styled(Link)`
  text-decoration: none;
`;

const FilterText = styled.span`
  font-weight: bold;
  font-size: 18px;
  line-height: 18px;
  padding: 12px 0;
  display: inline-block;
  text-transform: uppercase;
`;

const ClearAllText = styled.span`
  font-size: 16px;
  line-height: 16px;
  letter-spacing: 0.4px;
  cursor: pointer;
  transition: all 0.1s;
  display: block;
  padding: 12px 0;
  float: right;

  &:hover {
    color: #0CA58B;
  }
`;

const FilterWrapper = styled.div`
  display: block;
`;

const GenericBoothFilter = ({
  filterOptions,
  selectedFilter,
  setSelectedFilter,
  resetSelectedFilter,
  numOfExhibitors,
  onClick,
  subLevelOnClick,
  customOrder,
  filterCustomLabel,
}) => {
  const filterOrdering = useMemo(() => {
    if (FILTER_LIST.length > 0) {
      return FILTER_LIST;
    }
    return Object.keys(filterOptions).filter((filterOption) => filterOption !== 'count');
  }, [FILTER_LIST, filterOptions]);

  return (
    <>
      <HallFilterContainer>
        <MiniSiteNav>
          <StyledLink to={Routes.lobby}>
            Lobby
          </StyledLink>
          <ArrowFowardIcon
            style={{
              fontSize: '11px',
              margin: '0 6px',
            }}
          />
          Hall
        </MiniSiteNav>
        <FilterTitleContainer>
          <FilterText>
            Filter
          </FilterText>
          <ClearAllText onClick={resetSelectedFilter}>
            Clear all
          </ClearAllText>
        </FilterTitleContainer>
        <FilterWrapper>
          {filterOrdering?.map((filter, index) => (
            <FilterCategoryContainer
              label={filter}
              openOnMount={!index}
              customOrder={customOrder}
              filterCustomLabel={filterCustomLabel}
              selectedFilter={selectedFilter}
              filterOptions={filterOptions}
              filter={filter}
              onClick={onClick}
              subLevelOnClick={subLevelOnClick}
            />
          ))}
        </FilterWrapper>
      </HallFilterContainer>
    </>
  );
};

GenericBoothFilter.propTypes = {
  filterOptions: PropTypes.shape(),
  selectedFilter: PropTypes.shape().isRequired,
  setSelectedFilter: PropTypes.func.isRequired,
  resetSelectedFilter: PropTypes.func.isRequired,
  numOfExhibitors: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  subLevelOnClick: PropTypes.func.isRequired,
  customOrder: PropTypes.arrayOf(PropTypes.string).isRequired,
  filterCustomLabel: PropTypes.shape().isRequired,
};

GenericBoothFilter.defaultProps = {
  filterOptions: {},
};

export default GenericBoothFilter;
